import { AdminSearch } from '@platform/client';
import { DownloadResultsModal } from '../DownloadResultsModal';
import { repFiltersToQueryParams } from '../utils';
import { useState } from 'react';
import { AdminListPageWrapper } from '../../../AdminListPage';
import { RepUserSearchForm } from './RepUserSearchForm';
import { RepUserResultsTable } from './RepUserResultsTable';
import { RepUserFilters } from './RepUserSearchForm';

export const RepUserSearchPage = () => {
  const [filters, setFilters] = useState<RepUserFilters>();
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  return (
    <>
      {!filters && <RepUserSearchForm setFilters={setFilters} />}
      {filters && (
        <AdminListPageWrapper>
          <RepUserResultsTable
            filters={filters}
            setFilters={setFilters}
            setDownloadModalOpen={setDownloadModalOpen}
          />
        </AdminListPageWrapper>
      )}
      {downloadModalOpen && filters && (
        <RepUserDownloadModal
          filters={filters}
          onClose={() => {
            setDownloadModalOpen(false);
          }}
        />
      )}
    </>
  );
};

const RepUserDownloadModal = ({
  filters,
  onClose,
}: {
  filters: RepUserFilters;
  onClose: () => void;
}) => {
  const { data, isLoading, isError, isSuccess } = AdminSearch.useGetRepResultExportData(
    repFiltersToQueryParams(filters),
  );

  return (
    <DownloadResultsModal
      onClose={onClose}
      rows={data?.users ?? []}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      filenamePrefix='rep_export'
    />
  );
};
